

export default function SimpleArchiveSection({ list }) {
  return (
    <>
      {list}
    </>
  )
}
